import React, { useEffect, useState } from 'react';
import './install-prompt.css';

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function handleBeforeInstall(e) {
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true);
    }
    window.addEventListener('beforeinstallprompt', handleBeforeInstall);
    return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const choice = await deferredPrompt.userChoice;
    setVisible(false);
    setDeferredPrompt(null);
    console.log('PWA install choice', choice);
  };

  if (!visible) return null;

  return (
    <div className="pwa-install-wrap">
      <button className="pwa-install-btn" onClick={handleInstallClick}>Install App</button>
      <button className="pwa-install-dismiss" onClick={() => setVisible(false)}>Dismiss</button>
    </div>
  );
}
